import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchOverlayService } from '../../services/search-overlay.service';

@Component({
  selector: 'app-search-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (overlayService.showOverlay()) {
      <div class="search-overlay" (click)="onOverlayClick()">
      </div>
    }
  `,
  styles: [`
    .search-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;
    }
  `]
})
export class SearchOverlayComponent {
  protected readonly overlayService = inject(SearchOverlayService);

  onOverlayClick(): void {
    this.overlayService.hideOverlay();
  }
}